/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
import React, { useContext, useEffect, useState } from 'react';
import { Modal, Box, Grid, Tooltip } from '@mui/material';
import Draggable from 'react-draggable';
// import { Rnd } from 'react-rnd';
import Notification from '../../shared/notification-modal';
import { defaultModalOptions } from '../../shared/constantVariable';
import { closeIconBlack } from '../../shared/assets/images';
import { ExecuteContext } from '../Flow';
import ProductionSVG from './svg';
import { getCaptuBoolean } from '../userData';

const SemView = (props) => {
  const { showSemView, handleCloseSemView, roDetails } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const executeSchemanticViewData = useContext(ExecuteContext);
  const [closedLoop, setClosedLoop] = useState();
  const [bringPurge, setBringPurge] = useState();
  const [schmeticUnits, setSchmeticUnits] = useState();
  const [clro_captu, setClroCaptu] = useState(false);

  useEffect(() => {
    const { report_dict } = executeSchemanticViewData.reportData;
    if (report_dict && report_dict.clro_schematic) {
      // const key = Object.keys(report_dict.clro_schematic);
      setClosedLoop(report_dict.clro_schematic[roDetails.name]['Prod Cycle']);
      setBringPurge(report_dict.clro_schematic[roDetails.name]['Brine Purge']);
      setSchmeticUnits(report_dict.clro_schematic[roDetails.name].units);
      setClroCaptu(getCaptuBoolean());
    }
  }, []);
  return (
    <Draggable handle='.rodg-box'
      cancel='.no-drag'
      onStart={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}>
      <Modal
        hideBackdrop
        open={showSemView}
        onClose={handleCloseSemView}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="ro-modal"
      >
        <Box className='rodg-box schemic-diagam'>
          <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
          <Grid container className="ro-grid-container">
            <Grid item xs={12} className="ro-header-grid">
              <div className="ro-header-text rufusBld no_drag S_heading" id='roFeedName'>Schematic Diagram</div>
              <div className="ro-close-icon no_drag">
                <Tooltip title="Close">
                  <img src={closeIconBlack} alt="close" onClick={handleCloseSemView} style={{ width: '14px', padding: '11px' }}
                    className="pointer" />
                </Tooltip>
              </div>
            </Grid>
            <div style={{ maxHeight: 420, overflow: 'auto' }}>
              <div className='sem-closed-loop' style={{ position: 'relative' }}>
                <span className='M_Bold' style={{ display: 'block' }}>Production Loop</span>
                <span className='S_Regular' style={{ display: 'block' }}>CL Sequence Duration - {closedLoop && closedLoop['CL Sequence Duration'].toFixed(2)} min</span>
                <ProductionSVG loop='true' clro_captu={clro_captu} closedLoop={closedLoop} schmeticUnits={schmeticUnits} />
              </div>
              <div className='sem-bring-purge'>
                <span className='M_Bold' style={{ display: 'block' }}>Brine Purge</span>
                <span className='S_Regular' style={{ display: 'block' }}>BP Sequence Duration - {bringPurge && bringPurge['BP Sequence Duration'].toFixed(2)} min</span>
                <ProductionSVG loop='false' clro_captu={clro_captu} bringPurge={bringPurge} schmeticUnits={schmeticUnits} />
              </div>
              <div className='sem-legend'>
                <svg xmlns="http://www.w3.org/2000/svg" width="574" height="26" viewBox="0 0 574 26" fill="none">
                  <path d="M0 4C0 1.79086 1.79086 0 4 0H570C572.209 0 574 1.79086 574 4V21.5C574 23.7091 572.209 25.5 570 25.5H3.99999C1.79085 25.5 0 23.7091 0 21.5V4Z" fill="#F2F1F9" />
                  <path d="M12 13.5H14V15.5H16V11.5H18V9.5H15V8H14L15 4H23L24 8H23V9.5H20V11.5H22V15.5H24V13.5H26V21.5H24V20.5H14.5V21.5H12V13.5Z" fill="url(#paint0_linear_6664_32700)" />
                  <path d="M15 8.5H23V9.5H15V8.5Z" fill="#78BE21" />
                  <path d="M14.5 15.5H16V20.5H14.5V15.5Z" fill="#78BE21" />
                  <path d="M22 15.5H24V20.5H22V15.5Z" fill="#78BE21" />
                  <path d="M15 8.5V8H23V8.5H15Z" fill="#C1DB8A" />
                  <text fill="#1C1C1F" x='31' y='17' fontSize='10'>Electric Actuated Ball Valve</text>
                  <path d="M162 20H160V13H162V14H163.5V10H165V7.5H162.25C161.836 7.5 161.5 7.16421 161.5 6.75C161.5 6.33579 161.836 6 162.25 6H162.5C162.5 5.72386 162.724 5.5 163 5.5H168.5C168.776 5.5 169 5.72386 169 6H169.25C169.664 6 170 6.33579 170 6.75C170 7.16421 169.664 7.5 169.25 7.5H166.5V10H168V14H170V13H172V20H170V19H168C168 19 168 20 166 20C163.5 20 163.5 19 163.5 19H162V20Z" fill="url(#paint1_linear_6664_32700)" />
                  <path d="M162 14H163.5V19H162V14Z" fill="#78BE21" />
                  <path d="M168 14H169.5V19H168V14Z" fill="#78BE21" />
                  <path d="M162 7C162 6.72386 162.224 6.5 162.5 6.5H168.5C168.776 6.5 169 6.72386 169 7C169 7.27614 168.776 7.5 168.5 7.5H162.5C162.224 7.5 162 7.27614 162 7Z" fill="#78BE21" />
                  <path d="M163 6C163 5.72386 163.224 5.5 163.5 5.5H165.5C165.776 5.5 166 5.72386 166 6C166 6.27614 165.776 6.5 165.5 6.5H163.5C163.224 6.5 163 6.27614 163 6Z" fill="#C1DB8A" />
                  <text fill="#1C1C1F" x='176' y='17' fontSize='10'>Ball Valve</text>
                  <path fillRule="evenodd" clipRule="evenodd" d="M233 6.25H231V9.89H230V15.09H229V16.65H228V19.25H236.5V16.65H235.5V15.09H234.5V14.05H236V14.57H237V10.93H236V11.45H234.5V9.89H233V6.25Z" fill="#002D62" />
                  <text fill="#1C1C1F" x='242' y='17' fontSize='10'>Pressure Relief Valve</text>
                  <path d="M345 6.75C345 5.64543 345.895 4.75 347 4.75H359C360.105 4.75 361 5.64543 361 6.75V18.75C361 19.8546 360.105 20.75 359 20.75H347C345.895 20.75 345 19.8546 345 18.75V6.75Z" fill="#438D42" />
                  <text fill="#1C1C1F" x='365' y='17' fontSize='10'>Open Valve/ Pump</text>
                  <path d="M457 6.75C457 5.64543 457.895 4.75 459 4.75H471C472.105 4.75 473 5.64543 473 6.75V18.75C473 19.8546 472.105 20.75 471 20.75H459C457.895 20.75 457 19.8546 457 18.75V6.75Z" fill="#EE0000" />
                  <text fill="#1C1C1F" x='478' y='17' fontSize='10'>Close Valve/ Pump</text>
                  <defs>
                    <linearGradient id="paint0_linear_6664_32700" x1="13.4" y1="8.375" x2="20.0289" y2="27.9259" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#78BE21" />
                      <stop offset="1" stopColor="#132712" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_6664_32700" x1="161.2" y1="9.125" x2="166.546" y2="25.4346" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#78BE21" />
                      <stop offset="1" stopColor="#132712" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </Grid>
        </Box>
      </Modal>
    </Draggable >
  );
};

export default SemView;